export default {
  es: {
    enlaces: {
      fundacion: "/la-fundacion",
      mision: "/la-fundacion/mision",
      fundadores: "/la-fundacion/fundadores-y-miembros",
      transparencia: "/la-fundacion/transparencia",
      planesactuacion: "/la-fundacion/planes-de-actuacion",
      aguaparatodos: "/agua-para-todos",
      proyectosencurso: "/agua-para-todos/proyectos",
      proyectosfinalizados: "/agua-para-todos/proyectos-conseguidos",
      proyecto: "/proyecto",
      civsem: "/civsem",
      emprendimiento: "/empredimiento",
      mide: "/empredimiento/mide",
      patio: "/empredimiento/patio",
      contacto: "/contacto",
      colabora: "/colabora",
      noticias: "/noticias",
      noticia: "/noticia",
      aviso_legal: "/aviso-legal",
      gracias: "/gracias",
      login: "/login",
      registro: "/registro",
      areainterna: "/mi-perfil",
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      crearsuscripcion: "/crear-suscripcion",
      modificarsuscripcion: "/modificar-suscripcion",
    },
    formulario: {
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      introduce_mail: "Introduce tu email",
      password: "Contraseña",
      password_confirmation: "Repetir contraseña",
      pais: "País",
      telefono: "Teléfono",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado",
    },
    mensajes: {
      "C-0": {
        titulo: "Tarjeta guardada",
        cuerpo: "",
      },
      "C-1": {
        titulo: "Tarjeta erronea",
        cuerpo: "",
      },
      "C-2": {
        titulo: "¡Atención!",
        cuerpo: "Tienes que añadir la tarjeta",
      },
      "C-3": {
        titulo: "",
        cuerpo: "",
      },
      "C-4": {
        titulo: "",
        cuerpo: "",
      },
      "C-5": {
        titulo: "¡Atención!",
        cuerpo: "Ya tienes una suscripción activa",
      },
      "C-6": {
        titulo: "",
        cuerpo: "",
      },
      "EX-2": {
        titulo: "¡Atención!",
        cuerpo:
          "Este usuario ya tiene una suscripcion activa. Para modificarla contacta con nosotros",
      },
      // 'card_saved' => 'C-0',
      // 'card_not_found' => 'C-1',
      // 'not_card_selected' => 'C-2',
      // 'pay_not_confirmed' => 'C-3',
      // 'email_user' => 'C-4',
      // 'already_subs' => 'C-5',
      // 'not_sub' => 'C-6',
    },
    serviciosPatio: {
      emprendimiento: "Emprendedores",
      corporaciones: "Corporaciones",
      ciudadanos: "Ciudadanos",
      ecosistema: "Ecosistema",
	  administracion:'Administración pública'
    },
  },
  en: {
    enlaces: {
      actualidad: "/news",
      sala_de_prensa: "/press-room",
      contacto: "/contact",
      trabaja_con_nosotros: "/work-with-us",
      politica_privacidad: "/privacy-policy",
      politica_cookies: "/cookies-policy",
    },
  },
};



// WEBPACK FOOTER //
// ./src/translations/index.js